<footer class="w-full bg-[#263238] text-white py-6">
  <div
    class="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-center text-sm sm:text-base px-4"
  >
    <span>
      Crafted with passion in
      <span class="font-medium text-gray-300">Maryland, USA</span>
    </span>
    <span class="hidden md:inline text-gray-500">|</span>
    <span>
      &copy; {{ today | date : "Y" }} &middot;
      <span class="font-medium text-gray-300">(240) 877-8161</span>
    </span>
    <span class="hidden md:inline text-gray-500">|</span>
    <a
      href="https://thepracticalit.com"
      class="underline hover:text-blue-300 transition"
    >
      Practical Information Technology
    </a>
  </div>
</footer>
